import * as t from  './actionTypes';
import * as api from './api';

export function loadHome() {

  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.getHome((success, home, error) => {
      if (success) {
        dispatch({ type: t.HOME_LOAD_SUCCESS, home: home });
        dispatch({ type: t.UNSET_BUSY });
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
      }
    });
  }
}

export function editHome(data, successCB, errorCB) {
  return (dispatch) => {
    dispatch({ type: t.SET_BUSY });

    api.editHome(data, function(success, data, error) {
      if (success) {
        dispatch({ type: t.HOME_EDIT_SUCCESS, home: data });
        dispatch({ type: t.UNSET_BUSY });
        successCB();
      } else if (error) {
        dispatch({ type: t.UNSET_BUSY });
        errorCB(error);
      }
    })
  }
}
